import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

import Footer from "./Footer";
import Header from "./Header";
import variableColors from "../../_App.module.scss";

const { colorBlack, appBackgroundColor, colorDimGray } = variableColors;

const ButtonDiv = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: center;
  justify-content: center;
  align-items: center;
  align-content: center;
  a {
    color: inherit;
    text-decoration: inherit;
  }
`;

const BodyContainer = styled.div<{ $isDepartureMode: boolean }>`
  background-color: ${(props) => (props?.$isDepartureMode ? colorDimGray : appBackgroundColor)};
  color: ${colorBlack};
  width: 100%;
  height: calc(100vh - var(--constantFooterHeight) - var(--constantHeaderHeight));
`;

const FooterContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: auto;
`;

const NotFound = (): JSX.Element => {
  const { t } = useTranslation();

  const { pathname: pathName } = useLocation();
  const isDepartureMode: boolean = pathName?.includes("stopIds");
  // console.log({ isDepartureMode });

  return (
    <React.Fragment>
      <Header />

      <BodyContainer $isDepartureMode={isDepartureMode}>
        <h1 style={{ textAlign: "center", paddingTop: "6rem" }}>{t("404, Page Not Found")}</h1>
        <ButtonDiv>
          <Button variant="dark">
            <Link to="/app">{t("Go to the main page")}</Link>
          </Button>
        </ButtonDiv>
      </BodyContainer>

      <FooterContainer>
        <Footer />
      </FooterContainer>
    </React.Fragment>
  );
};

export default NotFound;
